import { Divider, Stack } from '@mui/material';
import { FlowDurationUnits } from 'flow-schema';
import { useState } from 'react';

import { Text, api } from 'common';

import { CallerPhoneNumberFormField } from './CallerPhoneNumberFormField';
import {
  BlockValueTemplateField,
  BlockValueTemplateFieldArea,
} from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { BlockRunModeField } from '../../ConfigFields/RunMode';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';
import { CommunicationWindowFormFields } from '../shared/CommunicationWindow';

export function SendSmsFormFields() {
  const { value: runMode } = useSelectedNodeField<api.FlowDefinition.RunMode>('config.runMode');
  const [isCommunicationWindowExpanded, setIsCommunicationWindowExpanded] = useState(true);
  return (
    <Stack spacing={2}>
      <BlockValueTemplateField
        fieldName="config.calleePhoneNumber"
        label="Recipient Phone Number"
        helperText="Provide a valid US or Canadian phone number in E.164 format (e.g. +14155551234 or +14165551234)"
        placeholder="+1-###-###-####"
        required
      />
      <CallerPhoneNumberFormField />
      <BlockValueTemplateFieldArea fieldName="config.message" label="Message" />
      <Text variant="subtitle2" bold>
        ⚠️ HIPAA Security Notice
      </Text>
      <Text variant="subtitle2">
        SMS communications are not encrypted or secure. DO NOT configure workflows that request,
        collect, or transmit PHI via SMS. <br></br> PHI includes: patient names, medical conditions,
        symptoms, medications, appointment details with providers, or any health-related
        information.
      </Text>
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[
          FlowDurationUnits.Hours,
          FlowDurationUnits.Minutes,
          FlowDurationUnits.Seconds,
        ]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
      />
      {
        // TODO: Remove runMode entirely from the SMS Block
        runMode === api.FlowDefinition.RunMode.Test && (
          <BlockRunModeField fieldName="config.runMode" label="Test Mode" />
        )
      }
      <Divider />
      <CommunicationWindowFormFields
        expanded={isCommunicationWindowExpanded}
        setIsExpanded={setIsCommunicationWindowExpanded}
        description="Set the valid windows during which communications can be sent."
        outsideWindowBehaviorVisibility="selectable"
      />
    </Stack>
  );
}
